// src/pages/DashboardPage.js
import React, { useEffect } from "react";
import DataList from "../components/Data/DataList";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { ShoppingBag, Users, CreditCard, TrendingUp } from "lucide-react";

function DashboardPage() {
  // const stats = [
  //   {
  //     title: "Total Items",
  //     value: "245",
  //     icon: <ShoppingBag />,
  //     color: "bg-blue-500",
  //   },
  //   {
  //     title: "Active Users",
  //     value: "2,345",
  //     icon: <Users />,
  //     color: "bg-green-500",
  //   },
  //   {
  //     title: "Total Revenue",
  //     value: "$23,455",
  //     icon: <CreditCard />,
  //     color: "bg-purple-500",
  //   },
  //   {
  //     title: "Growth",
  //     value: "+12.5%",
  //     icon: <TrendingUp />,
  //     color: "bg-amber-500",
  //   },
  // ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {/* {stats.map((stat, index) => (
          <Card key={index}>
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-500">
                    {stat.title}
                  </p>
                  <p className="text-3xl font-bold">{stat.value}</p>
                </div>
                <div className={`p-3 rounded-full ${stat.color}`}>
                  <div className="text-white">{stat.icon}</div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))} */}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Shop Item Management</CardTitle>
          <CardDescription>
            Manage your shop items, including images and details.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <DataList />
        </CardContent>
      </Card>
    </div>
  );
}

export default DashboardPage;
